import type { PlanImageCard } from './types'

export const DEFAULT_PLAN_IMAGE_CARD_NAME = 'Bild'

export const DEFAULT_PLAN_IMAGE_CARD_WIDTH_CM = 10

export const DEFAULT_PLAN_IMAGE_CARD_CONFIG: PlanImageCard['planConfig'] = {
  storeysForPlans: [],
  planTypes: [],
}

export const DEFAULT_PLAN_IMAGE_CARD_TEXT_STYLE: PlanImageCard['textStyle'] = {}

export const DEFAULT_PLAN_IMAGE_CARD_BORDER_STYLE: PlanImageCard['borderStyle'] = {}
